<template>
  <div>
    <div class="record-depot">
      <div class="main-box">
        <div class="depot-list-box">
          <div class="left-filter">
             <div class="ft-box" v-if="coDict && coDict.length > 0">
              <div class="tit">
                <i></i>责任者
                <span
                  :class="showAll[0] ? 'cur' : ''"
                  @click="showAllHandle(0)"
                ></span>
              </div>
              <div :class="showAll[0] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === coCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'co')"
                >
                  <span>全部</span>
                  <!-- <span>{{ coCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in coDict"
                  :key="'coDict' + index"
                  :class="getFacetText('coDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'co')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
          
            <div class="ft-box" v-if="genreDict && genreDict.length > 0">
              <div class="tit">
                <i></i>体裁
                <span
                  :class="showAll[1] ? 'cur' : ''"
                  @click="showAllHandle(1)"
                ></span>
              </div>
              <div :class="showAll[1] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === genreCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'genre')"
                >
                  <span>全部</span>
                  <!-- <span>{{ genreCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in genreDict"
                  :key="'genreDict' + index"
                 :class="getFacetText('genreDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'genre')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
              <div class="ft-box" v-if="bandDict && bandDict.length > 0">
              <div class="tit">
                <i></i>乐队
                <span
                  :class="showAll[2] ? 'cur' : ''"
                  @click="showAllHandle(2)"
                ></span>
              </div>
              <div :class="showAll[2] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === bandCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'band')"
                >
                  <span>全部</span>
                  <span>{{ bandCount }}</span>
                </div>
                <div
                  v-for="(item, index) in bandDict"
                  :key="'bandDict' + index"
                  :class="getFacetText('bandDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'band')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right-content">
            <a-spin class="page-load" v-if="pageLoad" />
            <div v-else>
              <div class="result-count">
                <div class="all-num">
                  <span
                    >共<b>{{ rowCount }}</b
                    >首</span
                  >
                  <b class="all-check" @click="allCheckClick">
                    <img
                      src="@/assets/images/icon/checked.png"
                      width="15"
                      v-if="allCheck == true"
                    />
                    <img
                      src="@/assets/images/icon/nochecked.png"
                      width="15"
                      v-else
                    />
                    全选
                  </b>
                </div>

                <div class="m-c-p">
                  <b
                    class="m-c-p-b"
                    :class="
                      continuationPlay.length == 0
                        ? 'continuation-play-empty'
                        : 'continuation-play'
                    "
                    @click="continuationClick"
                  >
                    <img
                      v-if="continuationPlay.length == 0"
                      src="@/assets/images/icon/disabled.png"
                      width="15"
                    />
                    <img
                      v-else
                      src="@/assets/images/icon/Group.png"
                      width="15"
                    />

                    连播<i>{{ continuationPlay.length }}</i></b
                  >
                  <div
                    :class="
                      showMobileFilter ? 'mb-filter-btn cur' : 'mb-filter-btn'
                    "
                    @click.stop="showMobileFilter = !showMobileFilter"
                  >
                    筛选
                  </div>
                </div>

                <div class="sort">
                  <span :class="sorts[0] ? 'cur' : ''" @click="onSorts(0)"
                    >题名</span
                  >
                  <span :class="sorts[1] ? 'cur' : ''" @click="onSorts(1)"
                    >责任者</span
                  >
                  <span
                    :class="
                      onlyShowPlay ? 'only-can-play cur' : 'only-can-play'
                    "
                    @click="onlyCanPlay"
                    >可播放曲目</span
                  >
                  <b
                    :class="
                      continuationPlay.length == 0
                        ? 'continuation-play-empty'
                        : 'continuation-play'
                    "
                    @click="continuationClick"
                  >
                    <img
                      v-if="continuationPlay.length == 0"
                      src="@/assets/images/icon/disabled.png"
                      width="15"
                    />
                    <img
                      v-else
                      src="@/assets/images/icon/Group.png"
                      width="15"
                    />

                    连播<i>{{ continuationPlay.length }}</i></b
                  >
                </div>
              </div>
              <div class="filter-keys" v-if="filterKeys.length > 0">
                <div class="lb">已选项：</div>
                <div
                  v-for="(f, index) in filterKeys"
                  :key="index + f.text"
                  class="f-k"
                >
                  {{ f.text }} <i class="cls" @click="deleteFilter(index)"></i>
                </div>
              </div>
              <div class="result-list">
                <div
                  v-for="(item, index) in recordList"
                  :key="'recordList' + index"
                  class="result-cell song-lt"
                >
                  <div class="song-check" @click="checkClick(item, index)">
                    <img
                      src="@/assets/images/icon/checked.png"
                      width="15"
                      v-if="item.check == true && item.playable == true"
                    />
                    <img
                      src="@/assets/images/icon/nochecked.png"
                      width="15"
                      v-if="item.check == false && item.playable == true"
                    />
                  </div>
                  <div class="index">{{ index + 1 }}</div>
                  <div class="pic">
                    <router-link
                      :to="'/song-detail/' + encodeURIComponent(item['@id'])"
                    >
                      <img :src="item.img || baseMusicPic" alt="" />
                      <!-- <img :src="item.img ||'/img/basemusic.png'" alt="" v-if="item.img ||'/img/basemusic.png'"> -->
                      <!-- <a-empty v-else :description="'暂无图片'" /> -->
                      <!-- <img v-else src="img/demo/image.png" alt=""> -->
                    </router-link>
                  </div>
                        <div class="info">
                       <router-link
                      :to="'/song-detail/' + encodeURIComponent(item['@id'])"
                    >
                    <div
                      class="name"
                      v-if="item.dctitle"
                      :title="item.dctitle['@value']"
                    >
                        {{ item.dctitle["@value"].replace(/~/,'')}}
                    </div>
                    <div class="des" v-if="item.creator">
                      <!-- <span>责任者</span>责任方式 -->
                      <span>{{
                        Array.isArray(item.creator)
                          ? item.creator.join("\xa0\xa0\xa0")
                          : item.creator
                      }}</span>
                    </div>
                        </router-link>
                     <router-link
                      :to="'/song-detail/' + encodeURIComponent(item['@id'])"
                    >
                    <div class="des" v-if="item.language">
                      语种：<span>{{ item.language }}</span>
                    </div>
                     </router-link>
                    <!-- <div class="des">
                    来自唱片<span>唱片名称</span>
                  </div> -->
                  </div>
                  <div class="count" v-if="item.extent">
                    {{ item.extent }}
                  </div>
                  <div class="act">
                    <span v-if="!item.playable" class="noplay"></span>
                    <span
                      v-if="item.playable"
                      :class="playIndex == index ? 'play curPlay' : 'play'"
                      @click="playSong(item, index)"
                    ></span>
                    <span
                      :class="item.isFavorite ? 'fav cur' : 'fav'"
                      @click="handleFav(index)"
                    ></span>
                    <!-- <span class="share"></span> -->
                    <ShareIcon
                      :shareConfig="{
                        url: '/song-detail/' + encodeURIComponent(item['@id']),
                        title: item.dctitle['@value'],
                      }"
                    ></ShareIcon>
                  </div>
                </div>
              </div>
              <div class="page-box">
                <a-pagination
                  :total="pagerCount"
                  :current="currentPage"
                  @change="onChange"
                  show-quick-jumper
                  show-less-items
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Player ref="player" @saveFav="saveFav" @curPlay="curPlay" />
    <div
      :class="showMobileFilter ? 'mobile-filter-tk cur' : 'mobile-filter-tk'"
    >
     <div class="depot-filter" v-if="coDict && coDict.length > 0">
        <span class="lb">责任者</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + coDict.length * 1.4 + 'rem'">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="coCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1,-1, 'co')"
              >全部</span
            >
            <span
              v-for="(item, index) in coDict"
              :key="'coDict' + index"
              :class="getFacetText('coDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item,index, 'co')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter" v-if="genreDict && genreDict.length > 0">
        <span class="lb">体裁</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + genreDict.length * 1.4 + 'rem'">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="genreCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1,-1, 'genre')"
              >全部</span
            >
            <span
              v-for="(item, index) in genreDict"
              :key="'genreDict' + index"
             :class="getFacetText('genreDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item,index, 'genre')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
     
      <div class="depot-filter" v-if="bandDict && bandDict.length > 0">
        <span class="lb">乐队</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + bandDict.length * 1.4 + 'rem'">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="bandCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1,-1, 'band')"
              >全部</span
            >
            <span
              v-for="(item, index) in bandDict"
              :key="'bandDict' + index"
              :class="getFacetText('bandDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item,index, 'band')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter">
        <div class="sort">
          <span
            :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
            @click="onlyCanPlay"
            >可播放曲目</span
          >
        </div>
      </div>
    
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import ShareIcon from "@/components/shareIcon";
import { baseMusicPic } from "@/util/basePic";
import { collCongList, collFav, ncollFav } from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player,
    ShareIcon,
  },
  data() {
    return {
      playIndex: -1,
      curIndex: -1,
      pageLoad: false,
      noplay: false,
      playerList: [],
      player: [],
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {},
      showMobileFilter: false,
      baseMusicPic,
      listType: 1,
      subjectCount: 0,
      subjectCurrent: -1,
      subjectDict: [],
      genreCount: 0,
      genreCurrent: -1,
      genreDict: [],
      artStyleCount: 0,
      artStyleCurrent: -1,
      artStyleDict: [],
      ariaCount: 0,
      ariaCurrent: -1,
      ariaDict: [],
      instrumentCount: 0,
      instrumentCurrent: -1,
      instrumentDict: [],
      bandCount: 0,
      bandCurrent: -1,
      bandDict: [],
      extentCount: 0,
      extentCurrent: -1,
      extentDict: [],
      coCount: 0,
      coCurrent: -1,
      coDict: [],
      audioDetail: [],
      facesTitleKey: [
        { key: "subject", title: "题材" },
        { key: "genre", title: "体裁" },
        { key: "artStyle", title: "风格流派" },
        { key: "aria", title: "唱法唱腔" },
        { key: "instrument", title: "乐器" },
        { key: "band", title: "乐队" },
        { key: "extent", title: "歌曲时长" },
        { key: "co", title: "责任者" },
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      totalPage: 10, // 每页总数
      recordList: [],
      showAll: [true, true, true],
      filterKeys: [],
      sorts: [true, false, false],
      hasAudio: false,
      onlyShowPlay: false,
      //全选
      allCheck: false,
      //连播
      continuationPlay: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.body.addEventListener("click", () => {
        this.showMobileFilter = false;
      });
      this.searchParams = this.commonParamsHandling();
      this.query();
    });
  },
  beforeDestroy() {
    document.body.removeEventListener("click", () => {
      this.showMobileFilter = false;
    });
  },
  methods: {
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      this.query();
    },
    //点击勾选
    checkClick(item, index) {
      let changeItem = item;
      changeItem.check = changeItem.check == false ? true : false;
      this.recordList.splice(index, 1, changeItem);
      //选择的歌曲加入到连播列表中
      if (changeItem.check == false) {
        for (let i = 0; i < this.continuationPlay.length; i++) {
          if (changeItem["@id"] == this.continuationPlay[i]["@id"]) {
            this.continuationPlay.splice(i, 1);
            i--;
          }
        }
      } else {
        this.continuationPlay = this.continuationPlay.concat(item);
      }
      this.listIsAllCheck();
    },
    //校验当前列表是否是全选状态
    listIsAllCheck() {
      let isAllCheck = true;
      for (let i = 0; i < this.recordList.length; i++) {
        if (this.recordList[i].check == false) {
          isAllCheck = false;
          break;
        }
      }
      this.allCheck = isAllCheck;
    },
    //点击全选
    allCheckClick() {
      this.allCheck = this.allCheck == false ? true : false;
      let that = this;
      let continuationPlayArr = JSON.parse(
        JSON.stringify(this.continuationPlay)
      );
      // console.log(this.continuationPlay,this.recordList,"!==1")
      this.recordList.forEach(function (item) {
        item.check = that.allCheck;
      });
      if (this.allCheck == true) {
        let arr = []
        this.recordList.forEach(function (item) {
          if(item.playable == true){
            arr.push(item)
          }
        });
        continuationPlayArr = continuationPlayArr.concat(arr);
      } else {
        for (let i = 0; i < this.recordList.length; i++) {
          for (let j = 0; j < continuationPlayArr.length; j++) {
            if (continuationPlayArr[j]["@id"] == this.recordList[i]["@id"]) {
              continuationPlayArr.splice(j, 1);
              j--;
            }
          }
        }
      }
      //连播列表进行去重
      if (continuationPlayArr.length != 0) {
        for (var i = 0; i < continuationPlayArr.length; i++) {
          for (var j = i + 1; j < continuationPlayArr.length; j++) {
            if (
              continuationPlayArr[i]["@id"] == continuationPlayArr[j]["@id"]
            ) {
              //第一个等同于第二个，splice方法删除第二个
              continuationPlayArr.splice(j, 1);
              j--;
            }
          }
        }
      }
      this.continuationPlay = continuationPlayArr;
    },
    //点击连播
    continuationClick() {
      if (this.continuationPlay.length == 0) {
        return;
      }
      for (var i = 0; i < this.continuationPlay.length; i++) {
        this.$refs.player.playSingleSong(
          this.$parent,
          this.continuationPlay[i]
        );
      }
    },
    initData() {
      // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    onParamsHandle() {
      // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      // 排序
      this.searchParams.sorts = {};
      if (this.sorts[0]) this.searchParams.sorts.TI = 1;
      if (this.sorts[1]) this.searchParams.sorts.CO = 1;
      if (this.sorts[2]) this.searchParams.sorts.TIME = 1;
      //仅显示可播放的唱片
      if (this.hasAudio)
        // this.searchParams.facet = { hasAudio: this.hasAudio + "" };
        this.searchParams.resouce = { PLAY: "1" };
      // 页码翻页
      this.searchParams.pager = {
        pageth: this.currentPage,
        pageSize: this.totalPage,
      };
      if (this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item, index) => {
        const dict = item.dict;
        // 简单检索
        if (dict == "keyword") {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if (dict.indexOf("Dict") != -1) {
          this.searchParams.facet[dict.replace("Dict", "").toUpperCase()] =
            item.text;
        }
      });
    },
    async query(facetsFlag = true) {
     // this.pageLoad = true;是否刷新画面
      // 参数设置
      this.onParamsHandle();
      const res = await collCongList(this.searchParams);
      //console.log(res);
      if (res) {
        this.pageLoad = false;
      }
      const data = res.data;
      // 内容
      this.recordList = data.datas;
      //列表默认增加一个非选中的状态，用来处理连播使用
      if (this.recordList.length != 0) {
        for (let i = 0; i < this.recordList.length; i++) {
          this.recordList[i]["check"] = false;
        }
      }
      //如果连播列表存在，需要更新check状态
      if (this.continuationPlay.length != 0) {
        for (let i = 0; i < this.continuationPlay.length; i++) {
          for (let j = 0; j < this.recordList.length; j++) {
            if (this.continuationPlay[i]["@id"] == this.recordList[j]["@id"]) {
              this.recordList[j].check = true;
            }
          }
        }
      }

      // 分面
      if (facetsFlag) {
        // 题材
        this.subjectDict =
          data.facets && data.facets.subjectFacet
            ? data.facets.subjectFacet
            : [];
        // 体裁
        this.genreDict =
          data.facets && data.facets.genreFacet ? data.facets.genreFacet : [];
        // 风格流派
        this.artStyleDict =
          data.facets && data.facets.artStyleFacet
            ? data.facets.artStyleFacet
            : [];
        // 唱法唱腔
        this.ariaDict =
          data.facets && data.facets.ariaFacet ? data.facets.ariaFacet : [];
        // 乐器
        this.instrumentDict =
          data.facets && data.facets.instrumentFacet
            ? data.facets.instrumentFacet
            : [];
        // 乐队
        this.bandDict =
          data.facets && data.facets.bandFacet ? data.facets.bandFacet : [];
        // 歌曲时长
        this.extentDict =
          data.facets && data.facets.extentFacet ? data.facets.extentFacet : [];
        // 责任者
        this.coDict =
          data.facets && data.facets.coFacet ? data.facets.coFacet : [];
      }
      // 统计数量
      this.facesTitleKey.forEach((item, index) => {
        this.countHnadle(item.key);
      });
      // 总数
      this.rowCount =
        data.pager && data.pager.rowCount ? data.pager.rowCount : 0;
      // 页码
      this.pagerCount =
        data.pager && data.pager.rowCount ? data.pager.rowCount : 1;
    },
    countHnadle(key) {
      // 统计数量
      this[key + "Count"] = 0;
      this[key + "Dict"].forEach((item, index) => {
        this[key + "Count"] += item.count;
      });
    },
    onSorts(n) {
      // 排序
      // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1;
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if (item == true) {
          allFalse = 2;
        }
      });
      if (allFalse == 1) {
        this.sorts[0] = true;
      }
      this.query(false);
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.query(false);
      this.allCheck = false;
    },
    showAllHandle(a) {
      this.showAll.splice(a, 1, !this.showAll[a]);
      let count = 0;
      this.showAll.forEach((item) => {
        if (item) {
          count++;
        }
      });
      if (count > 3) {
        let flag = false;
        this.showAll.forEach((item, index) => {
          if (item && index !== a && !flag) {
            flag = true;
            this.showAll.splice(index, 1, false);
          }
        });
      }
    },
    async handleFav(index) {
      //点击收藏如果没有登录,则提示用户登录后方可操作
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$message.open({
          content: "您还未登录,登陆后才能操作",
        });
        return;
      }
      const res = this.recordList[index].isFavorite
        ? await ncollFav({ uri: this.recordList[index]["@id"] })
        : await collFav({ uri: this.recordList[index]["@id"] });
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      this.isFavorite = !this.isFavorite;
      this.$refs.player.saveFav(this.recordList[index]);
      //取消收藏需要删除连播列表中的数据
      let changeItem = this.recordList[index];
      for (let i = 0; i < this.continuationPlay.length; i++) {
        if (changeItem["@id"] == this.continuationPlay[i]["@id"]) {
          this.continuationPlay.splice(i, 1);
          i--;
        }
      }

      this.$parent.coll(this.recordList[index].isFavorite);
      this.query();
    },
    saveFav(data) {
      this.query();
    },
    deleteFilter(index) {
      this[
        this.filterKeys[index].dict.substring(
          0,
          this.filterKeys[index].dict.search("Dict")
        ) + "Current"
      ] = -1;
      this.filterKeys.splice(index, 1);
      this.currentPage = 1;
      this.query();
    },
    getFacetText(key) {
     const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key ;
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      if(this.filterKeys[_i]){  return this.filterKeys[_i].text;}
      return '';
    },
    handleFilter(item, index, key) {
      
      this[key + "Current"] = item.facet ? item.facet : item;//被选中的分面值
      const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key + "Dict";
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      let facValue = this[key + "Dict"][index] && this[key + "Dict"][index].facet ? this[key + "Dict"][index].facet :'';//真正选中的分面值
      if (_i !== -1) {
          //如果是专题，则可以多选
          if(this.filterKeys[_i]){
            let tempList =this.filterKeys[_i].text.split(',');
              if(tempList.indexOf(facValue)==-1){//如果已转中数组中不存在当前值，则继续存入
                  if(facValue !=null && facValue!=''){
                  tempList.push(facValue);//被选中的主题分类数据
                  this.filterKeys[_i].text=tempList.join(',');
                  }
                  }
               else if(tempList.length>1) {//如果剩下的不是最后一个时候，允许移除
                tempList.splice(tempList.indexOf(facValue),1);//如果存在，则删除该值，重新查询
              }
              facValue =tempList.join(',');
           }
          if (index === -1) {
            this.filterKeys.splice(_i, 1);
            // console.log('index === -1')
          } else {
            this.filterKeys.splice(_i, 1, {dict: key + "Dict", text: facValue});
          }
      } else if(facValue !=null && facValue!=''){//选中的分面值，如果不为空 做新增
           this.filterKeys.push({dict: key + "Dict", text: facValue});
      }
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    // handleFilter(item, index, key) {
    //   this[key + "Current"] = item.facet ? item.facet : item;
    //   const _i = this.filterKeys.findIndex((item) => {
    //     return item.dict === key + "Dict";
    //   });
    //   if (_i !== -1) {
    //     if (index === -1) {
    //       this.filterKeys.splice(_i, 1);
    //     } else {
    //       this.filterKeys.splice(_i, 1, {
    //         dict: key + "Dict",
    //         text: this[key + "Dict"][index].facet,
    //       });
    //     }
    //   } else {
    //     this.filterKeys.push({
    //       dict: key + "Dict",
    //       text: this[key + "Dict"][index].facet,
    //     });
    //   }
    //   this.currentPage = 1;
    //   this.query();
    // },
    nohandleCancel() {
      this.noplay = false;
    },
    curPlay() {
      this.playIndex = this.curIndex;
    },
    playSong(item, index) {
      if (this.playIndex == index) {
        this.playIndex = -1;
        this.$refs.player.play();
        return;
      }
      this.curIndex = index;
      this.$refs.player.playSingleSong(this.$parent, item);
    },
  },
};
</script>
